import { format } from 'date-fns';

// types
import type { Material, Media, Resource } from './types/mynewsdesk.types';
import { type Locale } from 'date-fns';

// utils
import { generateSlug } from 'utils/slug';

export const categoryTabMap = {
  news: 0,
  media: 1,
};

export function sortByDate(a: Material, b: Material): number {
  return getTime(b) - getTime(a);
}

export function formatDate(material: Resource, locale: Locale | undefined): React.ReactNode {
  if (!material?.published_at?.datetime || !locale) {
    return null;
  }
  return format(new Date(material.published_at.datetime), 'dd LLLL uuuu kk:mm', {
    locale,
  });
}

function getTime(material: Material) {
  if (!material?.published_at?.datetime) {
    return 0;
  }

  return new Date(material.published_at.datetime).getTime();
}

export function getMaterialUniqueIdentifier(material: Material | Media): string {
  const slug = generateSlug(material?.header);

  return `${slug}-${material?.type_of_media.slice(0, 2).toUpperCase()}${material?.id}`;
}

export async function downloadMedia(media: Media) {
  const link = document.createElement('a');
  link.style.display = 'none';

  if (media.type_of_media === 'image' || media.type_of_media === 'video') {
    link.setAttribute('download', media.header);
    link.href = media.download_url;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  if (media.type_of_media === 'document') {
    link.setAttribute('download', media.document_name);
    const blob = await fetch(media.document, {
      method: 'GET',
    }).then((resp) => resp.blob());
    const url = window.URL.createObjectURL(blob);
    link.href = url;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }
}
